import React from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import Logo from '@wix/da-ds/pkg/Logo';
import { ThemeOptions, ThemeOverride, ThemeSurface } from '@wix/da-react-context/pkg/ThemeContext';
import UserLink from '../../User/Link';
import Modal, { Props as ModalProps } from '../../Popup/Modal';
import withPopupArt, { WithPopupArtProps } from '../withPopupArt';
import s from './ArtBrandedDesktopPopup.scss';

export interface Props {
  tagline?: string;
  title?: string;
  leftContent?: React.ReactNode;
  className?: string;
  taglineClassName?: string;
  overlayClassName?: string;
  titleClassName?: string;
  contentClassName?: string;
  onClose?: () => void;
  popupProps?: ModalProps;
  children?: React.ReactNode | undefined;
}

const ArtBrandedDesktopPopup: React.FC<Props & WithPopupArtProps> = ({
  artImageSrc,
  artAuthor,
  tagline,
  title,
  leftContent,
  className,
  taglineClassName,
  overlayClassName,
  titleClassName,
  contentClassName,
  onClose,
  popupProps = {},
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      className={s['modal']}
      closeBtnClassName={s['close-button']}
      onRequestClose={onClose}
      {...popupProps}
    >
      <ThemeOverride theme={ThemeOptions.LIGHT} themeSurface={ThemeSurface.TERTIARY} tag="div">
        <div className={classnames(s['root'], className)}>
          <div
            className={s['left']}
            style={{ backgroundImage: artImageSrc && `url(${artImageSrc})` }}
          >
            <div className={classnames(s['overlay'], overlayClassName)} />
            <div className={s['left-content']}>
              <Logo className={s['logo']} markColor="white" textColor="white" size="small" />
              {tagline ? (
                <div className={classnames(s['tagline'], taglineClassName)}>{tagline}</div>
              ) : (
                leftContent
              )}
              <div className={classnames(s['artist-credit'], artAuthor && s['loaded'])}>
                {artAuthor && (
                  <>
                    {t('common.artistCredit')}
                    <UserLink user={artAuthor} className={s['user-link']} />
                  </>
                )}
              </div>
            </div>
          </div>
          <div className={classnames(s['right'], contentClassName)}>
            {title && <div className={classnames(s['title'], titleClassName)}>{title}</div>}
            {children}
          </div>
        </div>
      </ThemeOverride>
    </Modal>
  );
};

export default withPopupArt(ArtBrandedDesktopPopup);
